import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ProjectItem } from "@/services/entities/ProjectItem";
import { useProjectStore } from "@/stores/project";
import { reactive } from "vue";
import { useVfm, VueFinalModal } from "vue-final-modal";
import ConfirmModal from "./ConfirmModal.vue";
import ProjectForm from "../project/ProjectForm.vue";
import { showToastError } from "@/toastification";
import { formatText } from "@/common/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateProjectModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const projectStore = useProjectStore();
const emit = __emit;

const state = reactive({
  value: {
    projectStart: new Date(),
    projectEnd: new Date(),
    projectType: 0,
    projectName: '',
    projectNumber: '',
    responsiblePerson: '',
    projectManager: '',
    nonBillableProjectType: 0,
    serviceId: null,
  } as any as ProjectItem,
});

const mandatoryFields = [
  {
    key: 0, values: [
      "projectName", "projectNumber", "responsiblePerson", "projectManager", "serviceId", "invoiceTypeId", "projectStart", "projectEnd"
    ]
  }, {
    key: 1, values: [
      "projectName", "projectNumber", "responsiblePerson", "projectManager", "projectStart", "projectEnd"
    ]
  }, {
    key: 2, values: [
      "projectName", "projectNumber", "responsiblePerson", "projectManager", "projectStart", "projectEnd"
    ]
  },
];

async function create() {
  let canCreate = true;
  if (state.value.projectStart > state.value.projectEnd) {
    showToastError("Project start date must be before project end date");
    canCreate = false;
  }
  state.value.projectStart = new Date(Date.UTC(state.value.projectStartPicker.year, state.value.projectStartPicker.month));
  state.value.projectEnd = new Date(Date.UTC(state.value.projectEndPicker.year, state.value.projectEndPicker.month + 1, 0));
  if (state.value.projectTypeId >= 0) {
    mandatoryFields.find(a => a.key == state.value.projectTypeId)?.values.forEach(element => {
      const value = state.value[element];
      if (value == null || value.length == 0) {
        showToastError(`Missing value: ${formatText(element)}`);
        canCreate = false;
      }
    });
    if (canCreate) {
      const projectId = await projectStore.createProject(state.value);
      emit("close", projectId);
    }
  } else {
    showToastError("Select project type")
  }
}

function beforeClose() {
  vfm.open(confirmModalId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onClickOutside: beforeClose
  }, {
    default: _withCtx(() => [
      _createVNode(ProjectForm, {
        value: state.value
      }, {
        header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "title" }, "Create project", -1)
        ]))]),
        buttons: _withCtx(() => [
          _createElementVNode("div", { class: "buttons" }, [
            _createElementVNode("button", { onClick: beforeClose }, "Cancel"),
            _createElementVNode("button", {
              class: "accent",
              onClick: create
            }, "Create project")
          ])
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(ConfirmModal, {
        "modal-id": _unref(confirmModalId),
        text: "You have unsaved changes, do you really want to leave this form?",
        "confirm-text": "Close form",
        onConfirm: _cache[0] || (_cache[0] = () => {
        _unref(vfm).close(_unref(confirmModalId));
        emit('close');
      }
        ),
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
      }, null, 8, ["modal-id"])
    ]),
    _: 1
  }))
}
}

})